import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { API_URLS, axiosRequest } from '@lib/axios';
import UserContext from '@lib/contexts/userContext';

/**
 * @typedef {Object} QuestionOption
 * @property {number} id
 * @property {number} question_id
 * @property {string} label
 * @property {string | null} code
 * @property {boolean} active
 * @property {number} display_order
 */

/**
 * @typedef {Object} Question
 * @property {number} id
 * @property {string} form_type
 * @property {string} slug
 * @property {string} label
 * @property {string | null} help_text
 * @property {string} type
 * @property {boolean} required
 * @property {boolean} active
 * @property {number} display_order
 * @property {QuestionOption[]} question_options
 */

/**
 * @typedef {Question[]} Questions
 */

/**
 * @typedef {import("@tanstack/react-query").UseQueryResult<Questions, Error>} FormsQueryResult
 */

/**
 * React Query wrapper for a form definition (GET /forms/:type)
 *
 * @param {string} formType
 * @returns {FormsQueryResult}
 */
const useFormQuery = (formType) => {
  const { authenticated } = useContext(UserContext);

  return useQuery({
    queryKey: ['forms', formType],
    queryFn: async () => axiosRequest({ method: 'GET', url: `${API_URLS.FORMS}/${formType}`}),
    enabled: authenticated,
    refetchOnWindowFocus: false,
    retry: false,
  });
};

export default useFormQuery;
